import { PropsWithChildren } from "react"
import { FaSpinner } from "react-icons/fa"

export function Button({
  disabled = false,
  processing = false,
  color = "blue",
  children,
  onClick,
}: PropsWithChildren<{
  disabled?: boolean
  processing?: boolean
  color?: "red" | "blue" | "gray" | "white"
  onClick?: () => void
}>) {
  let colorClass = {}
  if (color === "blue") {
    colorClass = {
      backgroundColor: "#00BCFF",
    }
  } else if (color === "red") {
    colorClass = {
      backgroundColor: "#FF4A4A",
    }
  } else if (color === "white") {
    colorClass = {
      backgroundColor: "#FFFFFF",
    }
  } else if (color === "gray") {
    colorClass = {
      backgroundColor: "#F3F4F6",
      color: "black",
    }
  }

  return (
    <button
      disabled={disabled}
      style={{ height: "160px", ...(disabled ? {} : colorClass) }}
      className="w-full rounded-2xl px-20 text-5xl font-bold leading-tight text-white hover:brightness-95 disabled:bg-gray-300"
      onClick={onClick}
    >
      {processing ? (
        <div className="flex flex-row items-center justify-center">
          <FaSpinner className="animate-spin text-5xl" />
          <div className="ml-4 text-5xl">처리중...</div>
        </div>
      ) : (
        <div>{children}</div>
      )}
    </button>
  )
}
